import store from "@/store";
import router from "@/router";
import { Message } from "element-ui";
import interceptorAuth from "./interceptorAuth";

export const successResponse = (config) => config;

export const errorResponse = (error) => {
  const { status } = error.response;

  if (status === 401) {
    let path = error.config.url.slice(error.config.baseURL.length, error.config.url.length);
    if (path !== "/auth") interceptorAuth();
  }

  if (status === 403) {
    Message({
      message: "Недостаточно прав",
      type: "error",
    });
  }

  // FIXME Понять зачем и исправить
  // if (data.ERROR !== "Токен устарел, сделай refresh") {
  //   Message({
  //     message: data.ERROR,
  //     type: "error",
  //   });
  // }

  return Promise.reject(error);
};
